<template>
    <div :id="galleryID">
        <div class="d-flex flex-wrap" style="gap: 5px;">
            <gallery-item v-for="(item, index) in images" :item="item" :index="index" :type="getType(item)" :key="`item-${galleryID}-${index}`" :grid="grid" />
        </div>
    </div>
</template>

<script>
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import GalleryItem from "./GalleryItem";
import PhotoSwipe from 'photoswipe';
export default {
    components: { GalleryItem },
    props: {
        galleryID: String,
        images: Array,
        grid: {
            default: false,
            type: Boolean
        }
    },
    methods:{
        getType(url) {
            let images = ['png', 'jpg', 'webp', 'jpeg', 'gif']
            let videos = ['mp4', 'avi']
            let ext = url.split('.').pop().toLowerCase()
            return images.includes(ext) ? 'image' : videos.includes(ext) ? 'video' : 'file'
        }
    },
    mounted() {
        if (!this.lightbox) {
            this.lightbox = new PhotoSwipeLightbox({
                gallery: '#' + this.$props.galleryID,
                children: 'a',
                // need to imrpove. subfolder not work.
                // pswpModule: () => import('photoswipe'),
                pswpModule: PhotoSwipe,
                bgOpacity: 0.9,
            });
            this.lightbox.init();
        }
    },
    unmounted() {
        if (this.lightbox) {
            this.lightbox.destroy();
            this.lightbox = null;
        }
    },
};
</script>
